


















































import { Component, Prop, Vue } from "vue-property-decorator";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component
export default class ReturObatHasilVerifikasi extends Vue {
  @Prop() retur!: any;

  formatDateTime(date: string) {
    return getHumanDateTime(date);
  }
}
